<template>
  <div id="confirmPopup" class="modal fade" role="dialog">
    <div class="modal-dialog profile-confirm-poup">
      <div class="modal-content">
        <div class="modal-header confirmpopup-bgcolor p-0">
          <div class="header-title">
            <div>{{ title }}</div>
            <div @click="closeModal()" class="close-icon cursor-pointer">
              <img src="/static/images/icons/ul_close_icon.svg" class="address-images" />
            </div>
          </div>
        </div>

        <div class="modal-body confirm-body">
          <div class="confirm-message">{{ confirmationText }}</div>
        </div>
          <div class="modal-footer confirmpopup-bgcolor col-xs-12 col-sm-12 d-flex-sm-end">
          <div class="">
            <button type="button" class="btn btn-block ok-button d-flex align-items-center" @click="closeModal()">{{ $t('OK') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: {
    title: String,
    confirmationText: String,
  },
  data() {
    return {
    };
  },
  methods: {
    closeModal() {
      $('#confirmPopup').modal('hide');
    },
    ok() {
    //   this.$emit('proceedChanges');
      $('#confirmPopup').modal('hide');
    },
  },
};
</script>

<style scoped>
.confirm-message {
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  color: #333333;

}
.modal-header {
    background-color: #ffffff !important;
    border-bottom: 1px solid #d3d3d3 !important;
    border-top-right-radius: 6px!important;
    border-top-left-radius: 6px!important;
}

.modal-header .close {
    background: unset;
    opacity: 1;
    line-height: unset;
    width: unset;
    border-radius: unset;
    color: unset;
    background-color: #ffffff !important;
}

.header-title {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    color: #1A1A1A;
    padding: 12px 0px 11px 16px;
}
.close-icon {
    padding-right: 16px;
}

.modal-body {
    padding: 27px 28px 3px 20px;
}

.ok-button,
.ok-button:hover {
    background-color: #01518a;
    height: 34px;
    min-width: 58px;
    color: #ffffff !important;
    font-size: 16px;
    font-weight: 600;
    border-radius: 3px;
    line-height: 25px;
    float: right;
    cursor: pointer;
    padding: 6px 16px;
}

.modal-footer {
    background-color: #fafaf9 !important;
    padding-right: 0px;
    border: none !important;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    padding-top:16px;
    padding-bottom: 16px;
}
.modal-content {
 border: none;
 border-top-right-radius: 6px!important;
 border-top-left-radius: 6px!important;
 border-bottom-right-radius: 0!important;
 border-bottom-left-radius: 0!important;
}

@media (min-width: 768px) {
.modal-dialog {
 width: 500px;
 margin: 30px auto;
}
}
</style>
